import React from "react";
import styles from "./TagsWidget.module.css";
import { useDictionaries } from "../../../hooks/useDictionaries";

const normalizeTagLabel = (tag, tagValueMap) => {
  if (tag == null) return "";

  if (typeof tag === "object") {
    const directValue = String(tag.name ?? tag.value ?? tag.label ?? "").trim();
    if (directValue) return directValue.startsWith("#") ? directValue : `#${directValue}`;
    const tagId = String(tag.tagId ?? tag.id ?? "").trim();
    const mappedValue = tagId ? tagValueMap.get(tagId) : "";
    return mappedValue ? `#${mappedValue}` : "";
  }

  const raw = String(tag).trim();
  if (!raw) return "";
  const mappedValue = tagValueMap.get(raw);
  if (mappedValue) return `#${mappedValue}`;
  return raw.startsWith("#") ? raw : "";
};

const TagsWidget = ({ tags = [] }) => {
  const { dictionaries } = useDictionaries(["tags"]);
  const tagValueMap = new Map(
    (dictionaries.tags ?? []).map((item) => [String(item.id), String(item.value || "").trim()]),
  );

  const resolvedTags = Array.from(
    new Set((Array.isArray(tags) ? tags : []).map((tag) => normalizeTagLabel(tag, tagValueMap)).filter(Boolean)),
  );

  if (!resolvedTags.length) return null;

  return (
    <section className={styles.tagsCard}>
      <div className={styles.section}>
        <span className={styles.widgetTitle}>
          <h5>Tags</h5>
        </span>
        <div className={styles.widgetGrid}>
          {resolvedTags.map((tag) => (
            <div className={styles.tagItem} key={tag}>
              <p className={styles.tagTitle}>{tag}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TagsWidget;

